export function parseBrowserType(browser: string): string {
  if (!browser) return '';
  const b = browser.toLowerCase();
  if (b.includes('chrome')) return 'chrome';
  if (b.includes('edge')) return 'edge';
  if (b.includes('safari')) return 'safari';
  if (b.includes('firefox')) return 'firefox';
  if (b.includes('opera')) return 'opera';
  if (b.includes('explorer') || b.includes('ie')) return 'explorer';
  return '';
}

export function parseOsType(os: string): string {
  if (!os) return '';
  const o = os.toLowerCase();
  if (o.includes('windows')) return 'windows';
  if (o.includes('mac') || o.includes('ios')) return 'apple';
  if (o.includes('linux')) return 'linux';
  if (o.includes('android')) return 'android';
  return '';
}

export function formatVisitDuration(seconds: number): string {
  if (!seconds || seconds <= 0) return '0s';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
}
